import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=08d69c6a"
import script from "./Organisation.vue?vue&type=script&lang=ts"
export * from "./Organisation.vue?vue&type=script&lang=ts"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=08d69c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports